import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './renew/services/analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    constructor(
        private primengConfig: PrimeNGConfig,
        private router: Router,
        private analytics: AnalyticsService
    ) {}

    ngOnInit(): void {
        this.primengConfig.ripple = true;

        // Initialiser GA4 et suivre chaque changement de route
        this.analytics.init();
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                this.analytics.trackPageView(event.urlAfterRedirects);
            });
    }
}
